import { api } from "@/lib/api";

export const PENDING_INVITE_KEY = "bf_pending_invite";

export function setPendingInvite(token) {
  if (token) localStorage.setItem(PENDING_INVITE_KEY, token);
}

// If the user just authenticated and had a pending invite, accept it.
// Returns true when the user successfully joined a team.
export async function consumePendingInvite() {
  const token = localStorage.getItem(PENDING_INVITE_KEY);
  if (!token) return false;
  localStorage.removeItem(PENDING_INVITE_KEY);
  try {
    await api.post(`/team/invites/${token}/accept`);
    return true;
  } catch {
    return false;
  }
}
